import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TTableColumn } from '@treezor/design-system';

import { usersHeaders, TUserRowType } from '@/features/user/store/allUsers.model';
import { useDashboardConfig } from '@/hooks/useDashboardConfig';

export function AllUsersHeader() {
  const { t } = useTranslation();
  const config = useDashboardConfig();

  const headers = usersHeaders.filter((header) =>
    header === 'userTag' ? config?.settings?.searchBar?.includes('userTag') : true,
  );

  const headerLabel = useMemo(
    () =>
      headers.map(
        (field: keyof TUserRowType): TTableColumn<TUserRowType> => ({
          name: field,
          field,
          label: field === 'actions' ? <></> : <span>{t(`pages.dashboard.users.table.${field}`)}</span>,
        }),
      ),
    [t, headers],
  );

  return headerLabel;
}
